import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams, Navigate, useLocation } from 'react-router-dom';
import GlobalStyle from './styles/GlobalStyle';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import AppointmentPage from './pages/AppointmentPage';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import BackToTopButton from './components/ScrollToTop/BackToTopButton';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import apiService from './utils/api';

// Sayfa başlığını güncelleme fonksiyonu
const updatePageTitle = (salonName: string, city?: string, district?: string) => {
  // Lokasyon bilgisi varsa ekle
  const locationStr = city && district ? `${city} ${district}` : 
                      city ? city : 
                      district ? district : 'Güzellik ve Bakım';
  
  // Salonun adını ve lokasyon bilgisini sayfa başlığına ekle
  document.title = `${salonName || 'Salon Websitesi'} | ${locationStr}`;
};

// Salon bileşeni - salonSlug parametresini alır
const SalonWebsite: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [website, setWebsite] = useState<any>(null);

  useEffect(() => {
    const fetchSalonWebsite = async () => {
      try {
        if (!slug) {
          setError('Salon bilgisi bulunamadı');
          setLoading(false);
          return;
        }

        const response = await apiService.getWebsiteBySlug(slug);
        if (response.success) {
          console.log('Salon bilgileri:', response.website);
          console.log('Logo:', response.website.salonInfo.logo);
          console.log('Testimonials:', response.website.testimonials);
          
          // Salon ID'sini global window objesine ata (diğer bileşenler için)
          if (response.website.salonInfo && response.website.salonInfo._id) {
            console.log('Salon ID global olarak ayarlanıyor:', response.website.salonInfo._id);
            (window as any).SALON_ID = response.website.salonInfo._id;
          }
          
          // Sayfa başlığını salon adına ve lokasyon bilgisine göre güncelle
          if (response.website.salonInfo) {
            const { name, city, district } = response.website.salonInfo;
            updatePageTitle(name, city, district);
          }
          
          setWebsite(response.website);
        } else {
          setError(response.message || 'Web sitesi içeriği alınamadı');
        }
      } catch (err) {
        setError('Web sitesi yüklenirken bir hata oluştu');
        console.error('Web sitesi yükleme hatası:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSalonWebsite();
  }, [slug]);

  // Sayfa değişikliklerinde sayfa başlığını güncellemek için location'ı takip et
  useEffect(() => {
    if (website && website.salonInfo) {
      const { name, city, district } = website.salonInfo;
      
      // Sayfa durumuna göre başlığı güncelle
      const pageName = location.pathname.split('/').pop() || '';
      let locationStr = city && district ? `${city} ${district}` : 
                        city ? city : 
                        district ? district : '';
      
      // Özel sayfa başlıkları ekleyebiliriz
      if (pageName === 'hizmetler') {
        document.title = `${name} | Hizmetlerimiz`;
      } else if (pageName === 'galeri') {
        document.title = `${name} | Galeri`;
      } else if (pageName === 'iletisim') {
        document.title = `${name} | İletişim`;
      } else if (pageName === 'randevu') {
        document.title = `${name} | Randevu Al`;
      } else {
        // Ana sayfa için salon adı ve lokasyon
        document.title = `${name} | ${locationStr || 'Güzellik ve Bakım'}`;
      }
    }
  }, [location, website]);

  if (loading) {
    return <div>Yükleniyor...</div>;
  }

  if (error || !website) {
    return <div>Hata: {error || 'Web sitesi bulunamadı'}</div>;
  }

  return (
    <>
      <Header salonInfo={website.salonInfo} />
      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage website={website} />} />
          <Route path="/hizmetler" element={<ServicesPage website={website} />} />
          <Route path="/galeri" element={<GalleryPage website={website} />} />
          <Route path="/iletisim" element={<ContactPage website={website} />} />
          <Route path="/randevu" element={<AppointmentPage website={website} />} />
        </Routes>
      </main>
      <Footer website={website} />
      <BackToTopButton />
    </>
  );
};

// Ana sayfa yönlendirme komponenti
const RedirectToBooking: React.FC = () => {
  useEffect(() => {
    // Ana domain'e girince randevu sistemine yönlendir
    window.location.href = 'https://randevu.345.com.tr';
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '18px',
      color: '#333'
    }}>
      Randevu sistemine yönlendiriliyorsunuz...
    </div>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <GlobalStyle />
        <ScrollToTop />
          <Routes>
          {/* Salon web sitesi için ana route */}
          <Route path="/:slug/*" element={<SalonWebsite />} />
          {/* Ana sayfa - randevu sistemine yönlendir */}
          <Route path="/" element={<RedirectToBooking />} />
          </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
